import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import { Button } from '@gjl/ui'
import { navLinks, contactCTA } from '@/lib/nav-links'

export function MobileNav() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="md:hidden">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isOpen}
        className="text-white"
      >
        {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
      </Button>

      {isOpen && (
        <div className="absolute top-full right-0 left-0 border-b border-white/10 bg-gray-900 p-4">
          <nav className="flex flex-col gap-4">
            {navLinks.map(({ href, label }) => (
              <Link
                key={href}
                to={href}
                className="hover:text-primary text-white transition"
                onClick={() => setIsOpen(false)}
              >
                {label}
              </Link>
            ))}
            <Link
              to={contactCTA.href}
              className="hover:text-primary text-white transition"
              onClick={() => setIsOpen(false)}
            >
              {contactCTA.label}
            </Link>
          </nav>
        </div>
      )}
    </div>
  )
}
